import { render, staticRenderFns } from "./register-person-form.vue?vue&type=template&id=566c355f&scoped=true&"
import script from "./register-person-form.vue?vue&type=script&lang=js&"
export * from "./register-person-form.vue?vue&type=script&lang=js&"
import style0 from "./register-person-form.vue?vue&type=style&index=0&id=566c355f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566c355f",
  null
  
)

export default component.exports